import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { WebUIThemeProvider } from 'web-ui-components/lib/utilities/themes';
import createStore from '../store/index';
import EffectiveWarningContainer from './EffectiveWarningContainer';
import envConfigPropTypes from '../states/envConfig/propTypes';
import sessionPropTypes from '../states/session/propTypes';
import { pages } from '../states/page/actions';
import { goToEWWarning } from './state/actions';
import { PaymentType } from './utils/constants';

class App extends React.Component {
	constructor(props) {
		super(props);
		const { session, effectiveWarning, envConfig, user, startPage } = this.props;
		this.state = { isLoading: true };

		this.store = createStore({
			session,
			effectiveWarning,
			envConfig,
			user,
			page: { name: startPage || pages.EffectiveWarning.paymentReason },
			// Dev Note: use 'warning' to test approver flow otherwise 'paymentReason'
		});
	}

	componentWillMount() {
		const { startPage, onContinue } = this.props;

		if (startPage === pages.EffectiveWarning.warning) {
			const { dispatch } = this.store;
			dispatch(goToEWWarning(PaymentType.FPS, onContinue)).then(() => this.setState({ isLoading: false }));
		} else {
			this.setState({ isLoading: false });
		}
	}

	render() {
		const { effectiveWarning, envConfig, onAction, onBack, onContinue, onPayment } = this.props;
		const { isLoading } = this.state;
		return isLoading ? null : (
			<Provider store={this.store}>
				<WebUIThemeProvider brandID={envConfig.brandId}>
					<div className="web-ui-components">
						<EffectiveWarningContainer
							effectiveWarning={effectiveWarning}
							onAction={onAction}
							onBack={onBack}
							onContinue={onContinue}
							onPayment={onPayment}
						/>
					</div>
				</WebUIThemeProvider>
			</Provider>
		);
	}
}

App.propTypes = {
	session: PropTypes.shape(sessionPropTypes).isRequired,
	envConfig: PropTypes.shape(envConfigPropTypes).isRequired,
	user: PropTypes.shape({ id: PropTypes.string }).isRequired,
	onAction: PropTypes.func.isRequired,
	onBack: PropTypes.func,
	onContinue: PropTypes.func.isRequired,
	onPayment: PropTypes.func,
	startPage: PropTypes.string,
	effectiveWarning: PropTypes.shape({}).isRequired,
};

export default App;
